module.exports = __webpack_public_path__ + "static/media/mongodb.75f1a992.svg";